import React from 'react';
import { Link } from 'react-router-dom'; 

export default function Footer() {
  return (
    <footer className="bg-primary-900 text-white">
      <div className="max-w-7xl mx-auto px-6 py-12 lg:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 items-start text-center md:text-left">
         
          {/* Logo and Description */}
          <div>
            <div className="flex justify-center md:justify-start items-center space-x-2 text-2xl font-bold mb-4">
              <i className="fas fa-leaf text-primary-400"></i>
              <span>GreenNest</span>
            </div>
            <p className="text-primary-200 mb-4">
              Bringing nature indoors for a healthier, greener living space.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li><Link to="/" className="text-primary-200 hover:text-white transition-colors">Home</Link></li>
              <li><Link to="/plants" className="text-primary-200 hover:text-white transition-colors">Plants</Link></li>
              <li><Link to="/about" className="text-primary-200 hover:text-white transition-colors">About Us</Link></li>
              <li><Link to="/contact" className="text-primary-200 hover:text-white transition-colors">Contact</Link></li>
              <li><Link to="/privacy" className="text-primary-200 hover:text-white transition-colors">Privacy Policy</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact Info</h3>
            <ul className="space-y-2 text-primary-200">
              <li className="flex justify-center md:justify-start items-center space-x-2">
                <i className="fas fa-envelope text-primary-400"></i>
                <span>hello@greennest.com</span>
              </li>
              <li className="flex justify-center md:justify-start items-center space-x-2">
                <i className="fas fa-phone text-primary-400"></i>
                <span>+880 1404845247</span>
              </li>
              <li className="flex justify-center md:justify-start items-center space-x-2">
                <i className="fas fa-map-marker-alt text-primary-400"></i>
                <span>Tongi, Gazipur City Corporation</span>
              </li>
            </ul>
          </div>

          {/* Social Media */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Follow Us</h3>
            <div className="flex justify-center md:justify-start space-x-4">
              <a href="https://instagram.com" className="w-10 h-10 bg-primary-800 hover:bg-primary-700 rounded-full flex items-center justify-center transition-colors">
                <i className="fab fa-instagram text-white"></i>
              </a>
              <a href="https://facebook.com" className="w-10 h-10 bg-primary-800 hover:bg-primary-700 rounded-full flex items-center justify-center transition-colors">
                <i className="fab fa-facebook-f text-white"></i>
              </a>
              <a href="https://pinterest.com" className="w-10 h-10 bg-primary-800 hover:bg-primary-700 rounded-full flex items-center justify-center transition-colors">
                <i className="fab fa-pinterest text-white"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-primary-800 mt-8 pt-8 text-center">
          <p className="text-primary-300">&copy; 2025 GreenNest. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
